import React from 'react'
import Dashboard from '../../dashboard'
import BillDetailsView from './billDetails'

const Bill = () => {
  return <Dashboard component={<BillDetailsView />} />
}

export default Bill
